import React, { useMemo } from "react";
import { Layer, Source } from "react-map-gl/mapbox";
import * as turf from "@turf/turf";

import { CIRCLE_LAYER_FILL_ID, CIRCLE_LAYER_OUTLINE_ID } from "../constants";

const CircleSource = ({ center }) => {
  const data = useMemo(
    () =>
      turf.circle(center, 0.5, {
        steps: 64, // number of points (smoothness)
        units: "kilometers",
      }),
    [center]
  );

  return (
    <Source id="circle-source" type="geojson" data={data}>
      <Layer
        id={CIRCLE_LAYER_FILL_ID}
        type="fill"
        paint={{
          "fill-color": "black",
          "fill-opacity": 0.15,
        }}
      />
      <Layer
        id={CIRCLE_LAYER_OUTLINE_ID}
        type="line"
        paint={{
          "line-color": "#4eb3f2",
          "line-width": 4,
          // Draw the ring at full opacity even where 3D buildings/terrain
          // would occlude it, so it stays visible in the pitched 3D view.
          "line-occlusion-opacity": 1,
        }}
      />
    </Source>
  );
};

export default CircleSource;
